import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const generateVisitorPDF = (facilityName, inmateName, inmateId, date, visitorsData) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginLeft = 10;
  const marginRight = 10;
  let startY = 55;

  const addWatermark = () => {
    doc.saveGraphicsState();
    doc.setGState(new doc.GState({ opacity: 0.08 }));
    doc.setFontSize(80);
    doc.setFont("times", "italic");
    doc.setTextColor(180, 180, 180);
    doc.text("Inmate Inbox", pageWidth / 2, pageHeight / 2, {
      align: "center",
      angle: 30,
    });
    doc.restoreGraphicsState();
  };

  const headerStyle = () => ({
    fontStyle: "bold",
    halign: "left",
    fontSize: 11,
    textColor: "black",
  });

  const contentStyle = () => ({
    fontSize: 10,
    textColor: "black",
  });

  const estimateVisitorTableHeight = (visitor) => {
    let baseRows = 5;
    if (visitor.Action !== "Approved") baseRows += 3;
    return baseRows * 14 + 8;
  };

  const drawVisitorTable = (visitor) => {
    const body = [
      [
        { content: "Action", styles: headerStyle() },
        { content: visitor.Action || "N/A", colSpan: 5, styles: contentStyle() },
      ],
      [
        { content: "Name", styles: headerStyle() },
        { content: visitor.Name || "N/A", styles: contentStyle() },
        { content: "DOB", styles: headerStyle() },
        { content: visitor.DOB || "N/A", styles: contentStyle() },
        { content: "Relation", styles: headerStyle() },
        { content: visitor.Relation || "N/A", styles: contentStyle() },
      ],
      [
        { content: "Phone Number", styles: headerStyle() },
        { content: visitor.PhoneNumber || "N/A", styles: contentStyle() },
        { content: "Address", styles: headerStyle() },
        { content: visitor.Address || "N/A", styles: contentStyle() },
        { content: "City", styles: headerStyle() },
        { content: visitor.City || "N/A", styles: contentStyle() },
      ],
      [
        { content: "State", styles: headerStyle() },
        { content: visitor.State || "N/A", colSpan: 2, styles: contentStyle() },
        { content: "ZIP", styles: headerStyle() },
        { content: visitor.ZIP || "N/A", colSpan: 3, styles: contentStyle() },
      ],
      [
        { content: "Resubmitted Date", styles: headerStyle() },
        { content: visitor.ResubmittedDate || "N/A", colSpan: 2, styles: contentStyle() },
        { content: "Responded Date", styles: headerStyle() },
        { content: visitor.RespondedDate || "N/A", colSpan: 3, styles: contentStyle() },
      ],
    ];

    if (visitor.Action !== "Approved") {
      body.push([
        { content: "DISAPPROVAL SECTION", colSpan: 6, styles: headerStyle() },
      ]);
      body.push([
        { content: visitor.DissaprovalSection || "N/A", colSpan: 6, styles: contentStyle() },
      ]);
      body.push([
        { content: "Others", styles: headerStyle() },
        { content: visitor.Others || "N/A", colSpan: 5, styles: contentStyle() },
      ]);
    }

    autoTable(doc, {
      startY,
      margin: { left: marginLeft, right: marginRight },
      body,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 2.5,
        valign: "middle",
        overflow: "linebreak",
        minCellHeight: 12,
        lineColor: [0, 0, 0], 
      },
      columnStyles: {
        0: { cellWidth: 30 },
        1: { cellWidth: 30 },
        2: { cellWidth: 30 },
        3: { cellWidth: 30 },
        4: { cellWidth: 30 },
        5: { cellWidth: 30 },
      },
      willDrawCell: (data) => {
        if (startY + estimateVisitorTableHeight(visitor) > pageHeight - 30) {
          doc.addPage();
          addPageHeader(doc);
          startY = 55;
        }
      },
    });

    startY = doc.previousAutoTable.finalY + 10;
  };

  const addPageHeader = (doc) => {
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(16);
    doc.text("Visitor Information", pageWidth / 2, 18, { align: "center" });

    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(10);
    doc.setTextColor(255, 145, 2);
    doc.text("Name", marginLeft, 28);
    doc.text("Resident ID", marginLeft, 33);
    doc.text("Facility", marginLeft, 38);
    doc.text("Date", marginLeft, 43);

    doc.setTextColor(255, 145, 2);
    doc.text(inmateName || "-", marginLeft + 32, 28);
    doc.text(inmateId || "-", marginLeft + 32, 33);
    doc.text(facilityName || "-", marginLeft + 32, 38);
    doc.text(date || "-", marginLeft + 32, 43);
  };

  // Create first header before looping
  addPageHeader(doc);

  visitorsData.forEach((visitor) => {
    const estimatedHeight = estimateVisitorTableHeight(visitor);
    if (startY + estimatedHeight > pageHeight - 30) {
      doc.addPage();
      addPageHeader(doc);
      startY = 55;
    }
    drawVisitorTable(visitor);
  });

  // Watermark and footer
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    addWatermark();
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - marginRight, pageHeight - 10, {
      align: "right",
    });
  }

  doc.save("Visitor_Info.pdf");
};

export default generateVisitorPDF;
